import axios from "@/plugins/axios";

let url = "/api/console/nshop/vaccount-payments";

/** @typedef {object} Payment */

export const vaccountPayments = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, payments: Payment[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ payment: Payment }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<Payment>} data
     * @returns {Promise<{ payment: Payment }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
};

export default vaccountPayments;
